// Delegate all draft persistence to the unified essaySubmissions collection.
// This keeps the composable (useAutosaveDraft) interface unchanged while
// ensuring drafts appear alongside submissions in Essay History.
import { upsertDraftSubmission, loadDraftSubmission } from "@/services/essaySubmissions";

export async function saveEssayDraft(promptId, essayText, options = {}) {
  return upsertDraftSubmission(promptId, essayText, options);
}

export async function loadEssayDraft(promptId) {
  return loadDraftSubmission(promptId);
}

/** No-op: draft→pending promotion is handled by createEssaySubmission. */
export async function markDraftSubmitted() {}

// ── localStorage helpers (logged-out / offline fallback) ──────────────────────

function localKey(promptId) {
  return `essayDraft_${promptId}`;
}

export function saveLocalDraft(promptId, essayText) {
  try {
    localStorage.setItem(
      localKey(promptId),
      JSON.stringify({ essayText, lastSavedAt: new Date().toISOString() })
    );
  } catch {
    // storage quota exceeded – silently ignore
  }
}

export function loadLocalDraft(promptId) {
  try {
    const raw = localStorage.getItem(localKey(promptId));
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearLocalDraft(promptId) {
  try {
    localStorage.removeItem(localKey(promptId));
  } catch {
    // ignore
  }
}
